import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { CustomizationTheme } from "@graylog/enterprise-api";
import AppConfig from "util/AppConfig";
const fetchCustomColors = (fromAppConfig, defaultCustomColors) => {
  if (fromAppConfig) {
    return Promise.resolve(defaultCustomColors);
  }
  return CustomizationTheme.getThemeOverrides();
};
const useCustomThemeColors = (fromAppConfig = true) => {
  const defaultCustomColors = fromAppConfig ? AppConfig.customThemeColors() : null;
  const { data, isInitialLoading } = useQuery({
    queryKey: ["customization", "colors"],
    queryFn: () => fetchCustomColors(fromAppConfig, defaultCustomColors),
    placeholderData: keepPreviousData,
    enabled: !fromAppConfig,
    initialData: defaultCustomColors
  });
  return { data, isInitialLoading };
};
export default useCustomThemeColors;
